import Sentry from "@similarweb/sentry-logger";
import { allTrackers } from "../track/track";
import * as _ from "lodash";

function isWERunning() {
    return _.isObject(window["webengage"]);
}

export function openSurvey(surveyId, force) {
    // invoking webengage.survey.render with specific survey id
    return (
        isWERunning() &&
        window["webengage"].survey.render({
            surveyId: surveyId,
            forcedRender: force,
            skipRules: force,
        })
    );
}

export function registerSurveyListeners() {
    if (!isWERunning()) {
        return;
    }

    const survey = window["webengage"].survey;
    survey.onOpen(function () {
        allTrackers.trackEvent("Pop Up", "open", "NPS survey");
    });

    survey.onClose(function () {
        allTrackers.trackEvent("Pop Up", "close", "NPS survey");
    });

    survey.onComplete(function () {});

    survey.onSubmit(function (data) {
        // send data to marketo
        try {
            const marketoData = {
                NPS_Score__c: _.get(_.find(data.questionResponses, { value: { "@class": "score" } }), "value.value"),
                NPS_Survey_Date__c: new Date().toISOString(),
                NPS_Additional_Details__c: _.get(
                    _.find(data.questionResponses, { value: { "@class": "text" } }),
                    "value.text",
                ),
            };
            allTrackers.trackEvent("Pop Up", "submit-ok", "NPS survey/" + marketoData.NPS_Score__c);
        } catch (e) {
            Sentry.error("error submitting webengage survey", e);
        }
    });

    try {
        survey.options("defaultRender", false);
        window["webengage"].onReady(function () {
            window["webengage"].survey.render();
        });
    } catch (e) {}
}
